export default __webpack_public_path__ + "static/media/benefit_2@3x.a12a106b.png";